import { postRequest, getRequest, putRequest } from "../../config/axiosConfig";
import { getAdminAccessToken } from "../../utils/tokenUtils";
const BASE = process.env.REACT_APP_BASE_URL;

// 1) company/get-all-company
// (Your backend is using POST for listing; keep it as POST)
export const getAllCompany = async (payload = {}) => {
  try {
    const response = await getRequest({
      url: `${BASE}company/get-all-company`,
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response?.data ?? response,
        message: "Companies",
      };
    }

    return {
      success: false,
      data: response?.data ?? response,
      message: "Failed",
    };
  } catch (error) {
    return { success: false, data: null, message: error?.message || "Error" };
  }
};

// 2) company/get-company-by-id
// Body: { id: "..." }
export const getCompanyById = async (company_id) => {
  try {
    const response = await postRequest({
      url: `${BASE}company/get-company-by-id`,
      data: { id: company_id },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response?.data ?? response,
        message: "Company",
      };
    }

    return {
      success: false,
      data: response?.data ?? response,
      message: "Failed",
    };
  } catch (error) {
    return { success: false, data: null, message: error?.message || "Error" };
  }
};

// helper: convert plain object -> FormData
const toFormData = (obj = {}) => {
  const fd = new FormData();
  Object.entries(obj).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    // If you pass File/Blob it will work, and if you pass arrays you can append multiple
    if (Array.isArray(value)) {
      value.forEach((v) => fd.append(key, v));
    } else {
      fd.append(key, value);
    }
  });
  return fd;
};

// 3) company/create-company
// Send ALL request data in FormData (including files if any)
export const createCompany = async (formValues) => {
  try {
    const formData = toFormData(formValues);

    const response = await postRequest({
      url: `${BASE}company/create-company`,
      data: formData,
      // Usually DON'T set Content-Type manually for FormData in browser (axios will set boundary) [web:1]
      // headers: { "Content-Type": "multipart/form-data" },
    });

    if (response?.status === 200 || response?.status === 201) {
      return {
        success: true,
        data: response?.data ?? response,
        message: "Created",
      };
    }

    return {
      success: false,
      data: response?.data ?? response,
      message: "Failed",
    };
  } catch (error) {
    return { success: false, data: null, message: error?.message || "Error" };
  }
};

// 4) company/update-company
// Send ALL request data in FormData (including company_id and files if any)
export const updateCompany = async (formValues) => {
  try {
    const formData = toFormData(formValues);

    const response = await putRequest({
      url: `${BASE}company/update-company`,
      data: formData,
      // Usually DON'T set Content-Type manually for FormData in browser (axios will set boundary) [web:1]
      // headers: { "Content-Type": "multipart/form-data" },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response?.data ?? response,
        message: "Updated",
      };
    }

    return {
      success: false,
      data: response?.data ?? response,
      message: "Failed",
    };
  } catch (error) {
    return { success: false, data: null, message: error?.message || "Error" };
  }
};
